export const PRODUCT_LIST_REQUEST = "PRODUCT_LIST_REQUEST";
export const PRODUCT_LIST_SUCESS = "PRODUCT_LIST_SUCESS";
export const PRODUCT_LIST_FAIL = "PRODUCT_LIST_FAIL";
export const PRODUCT_LIST_LOADING = "PRODUCT_LIST_LOADING";

export const LIST_CART = "LIST_CART";
export const TOOGLE_SWITCHER = "TOOGLE_SWITCHER";
